import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  summaryCard: {
    backgroundColor: "rgba(244, 242, 255, 0.05)",
    borderRadius: "2rem",
    padding: theme.spacing(4),
    border: "1px solid rgba(223, 224, 255, 0.1)",
    boxShadow: "0 20px 80px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    minHeight: 400,
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "rgba(223, 224, 255, 0.2)",
      boxShadow: "0 24px 90px rgba(0,0,0,0.4)",
    },
  },

  summaryHeader: {
    color: theme.palette.text.sumaryHeader,
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    textAlign: "left",
    marginBottom: theme.spacing(4),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  itemsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  itemLabel: {
    color: theme.palette.text.investementItem,
    fontSize: 14,
    fontWeight: 500,
  },

  itemValue: {
    color: theme.palette.text.invesment,
    fontSize: 14,
    fontWeight: 600,
  },

  totalSection: {
    marginTop: "auto",
    paddingTop: theme.spacing(3),

    borderTop: `0.1px solid ${theme.palette.text.backButton}`,
  },

  totalLabelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
  },

  totalLabel: {
    color: "rgba(6, 232, 159, 0.6)",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "1.2px",
  },

  liveRateBadge: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },

  liveRateDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#06e89f",
    boxShadow: "0 0 8px #06e89f",
    animation: "$pulse 2s infinite",
  },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.6,
    },
  },

  liveRateText: {
    color: "#06e89f",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: "0.8px",
  },

  totalAmount: {
    color: theme.palette.text.invesment,
    fontSize: "2.5rem",
    fontWeight: 800,
    letterSpacing: "-0.02em",
  },
}));

export { useStyles };
